import { EnvironmentModel } from './environment-model';

// export const environment: EnvironmentModel = {
//   production: true,
//   apiUrl: 'http://apikhaosat.ncse.edu.vn/api/',
//   apiUrlFe: 'http://khaosat.ncse.edu.vn/',
//   ver: 'v1.0',
// };

// export const environment: EnvironmentModel = {
//   production: true,
//   apiUrl: 'http://school_nktapi.epmt.com.vn:2019/api/',
//   apiUrlFe: 'http://test.ncse.edu.vn:2019/',
//   ver: 'v1.0',
// };

export const environment: EnvironmentModel = {
  production: true,
  apiUrl: 'http://be.ncse.edu.vn/api/',
  apiUrlFe: 'http://csdl.ncse.edu.vn/',
  ver: 'v1.0',
};